<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>

    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <p-accordion [activeIndex]="0">
            <p-accordionTab header="Facturas recibidas vía FacturaFácil">
                <div class="card">
                    <div class="flex align-items-center justify-content-between mb-2">
                        <h5 class="m-0">Facturas recibidas vía FacturaFácil</h5>
                    </div>
                    <p-table #dt [value]="facturas" [columns]="cols" dataKey="id"
                             selectionMode="multiple" [(selection)]="facturasSeleccionados"
                             [rowHover]="true" [rows]="10" [paginator]="true"
                             [scrollable]="false" [responsive]='true'
                             [filterDelay]="0" [globalFilterFields]="['secuencial','subjectFullName','resumen']"
                             sortMode="multiple" [multiSortMeta]="multiSortMeta"
                             [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                             styleClass="p-datatable-striped">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <span class="p-input-icon-left ml-1 w-full mr-2">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                           placeholder="Buscar.."
                                           class="w-full"/>
                                </span>
                                <p-button id="notification-button"
                                          pTooltip="Ver totales" tooltipPosition="bottom"
                                          styleClass="p-button-text p-button-sm"
                                          (click)="verTotalesFacturas($event, 'main')">
                                    <ng-template pTemplate="content">
                                        <img alt="bug" src="assets/layout/icons/dollar.png" style="width: 2rem" />
                                        <span *ngIf="!enabledTotals" id="notification-note">/</span>
                                    </ng-template>
                                </p-button>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible" [ngClass]="col.class">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{col.header}}
                                    <p-sortIcon [field]="col.field"></p-sortIcon>
                                </div>
                            </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                                <td style="width: 3rem">
                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                            </td>
                            <td *ngFor="let col of columns" [hidden]="!col.visible" [ngClass]="col.class">
                                <span *ngIf="col.field != 'isPayment'"> {{col.field == 'importeTotal' ? ('$'+rowData[col.field].toFixed(2)) :  rowData[col.field]}}</span>
                            </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td>{{appConfig.ux.emptyMsg}}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <button pButton type="button" 
                                    pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                                    icon="pi pi-refresh" class="p-button-rounded p-button-text"
                                    (click)="dt.reset();">
                            </button>
                        </ng-template>
                    </p-table>
                </div>
            </p-accordionTab>

            <p-accordionTab header="Compras registradas desde el SRI">
                <!-- Compras registradas desde el SRI -->
                <div class="card">
                    <div class="flex align-items-center justify-content-between mb-2">
                        <h5 class="m-0">Compras registradas desde el SRI</h5>
                        <button pButton type="button" label="Importar del SRI" icon="pi pi-download"
                                class="p-button-sm p-button-outlined" (click)="abrirImportar()"></button>
                    </div>
                    <p-table [value]="comprasRecibidas" [rows]="10" [paginator]="true" dataKey="uuid"
                             styleClass="p-datatable-striped" [responsive]="true"
                             currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} compras">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Fecha Emisión</th>
                                <th>Secuencial</th>
                                <th>Proveedor</th>
                                <th>Clave de acceso</th>
                                <th class="p-text-right">Total</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-c>
                            <tr>
                                <td>{{ c.fechaEmision | date:'dd/MM/yyyy' }}</td>
                                <td>{{ c.secuencial }}</td>
                                <td>{{ c.proveedorNombre }}</td>
                                <td><small>{{ c.claveAcceso }}</small></td>
                                <td class="p-text-right">{{ c.total != null ? ('$' + c.total.toFixed(2)) : '' }}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr><td colspan="5">Aún no hay compras importadas del SRI. Use "Importar del SRI" o la extensión Fazil SRI Connector.</td></tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>

<!-- Diálogo: Importar comprobantes del SRI por clave de acceso -->
<p-dialog header="Importar comprobantes del SRI" [(visible)]="mostrarImportar" [modal]="true" [style]="{width: '40rem'}">
    <p class="text-600">
        Pegue las claves de acceso (49 dígitos) de los comprobantes recibidos, una por línea.
        Fazil descargará el XML autorizado de cada una desde el SRI y registrará la compra.
        Los duplicados se omiten automáticamente.
    </p>
    <textarea pInputTextarea [(ngModel)]="clavesTexto" rows="8" class="w-full"
              placeholder="0506202601176815256000120017772496587700306202615&#10;0606202601179125123700120010651084979971234567811"></textarea>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancelar" icon="pi pi-times"
                class="p-button-text" (click)="mostrarImportar = false"></button>
        <button pButton type="button" label="Importar" icon="pi pi-download"
                [disabled]="importando" (click)="importarDesdeSRI()"></button>
    </ng-template>
</p-dialog>